import _ from 'lodash'
import { post } from 'providers/http'

export default (namespace, computedNameOrFuncs, searchConfig, funcs) => {
  let computedName = computedNameOrFuncs
  let functions = funcs

  if (_.isObject(computedNameOrFuncs)) {
    computedName = namespace
    searchConfig = computedNameOrFuncs
    functions = searchConfig
  }

  return {
    data () {
      return {
        [computedName + 'Results']: []
      }
    },
    computed: {
      [computedName || namespace] () {
        let entities = this[computedName + 'Results']

        if (functions && functions.filter) {
          entities = entities.filter(functions.filter.bind(this))
        }

        if (functions && functions.map) {
          entities = entities.map(functions.map.bind(this))
        }

        if (functions && functions.sort) {
          entities = entities.sort(functions.sort.bind(this))
        }

        return entities
      }
    },
    methods: {
      async ['fetch' + capitalizeFirstLetter(computedName)] () {
        const params = _.isFunction(searchConfig) ? searchConfig.call(this, this) : searchConfig

        const { data } = await post(`api/v1/${namespace}/search`, params)

        this[computedName + 'Results'] = data
      }
    },
    async beforeMount () {
      this['fetch' + capitalizeFirstLetter(computedName)]()
    }
  }
}

function capitalizeFirstLetter (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}



// WEBPACK FOOTER //
// ./src/service/search.js